import React, { useEffect, useState } from 'react';
import styles from './index.module.less';
import { Breadcrumb, Button, Col, Row, Tooltip, Tag } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import CustomLayout from '@/common/Layout/index';
import emptyState from '../../../admin-doa-envelope/images/empty.svg';
import SearchBar from '@/common/Content/searchBar';
import CustomTable from '@/common/Content/CustomTable';
import { EditOutlined } from '@ant-design/icons';
// EyeOutlined, DeleteOutlined
import { useDispatch, useSelector } from 'react-redux';
import {
  getcustnumNumId,
  getCostCenterNum,
  getPlants,
  getfunctions
  // deleteCostCenter
} from '../../redux/slice';
// import Pencil from '@/pages/initiate-envelope/images/Pencilsvg';
import AddModal from './AddModal';
import EditModal from './EditModal';

const Categories = () => {
  const {
    get_costcenterNums,
    pagination,
    getCUSTNum_id,
    get_plants,
    get_functions
  } = useSelector((state) => state.settings);

  console.log('get_plants', get_plants);
  console.log('get_functions', get_functions);

  // const { plant_id } = useSelector((state) => state.settings);
  // byIdLoading
  // console.log('get_costcenterNums', get_costcenterNums);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [id, setId] = useState('');
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [departmentSearch, setDepartmentSearch] = useState('');
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const showEditModal = (id) => {
    let payload = {
      id: id,
      user: 'admin'
    };
    dispatch(getcustnumNumId(payload));
    console.log('getcustnumNumId', id);

    setIsEditModalOpen(true);
  };
  const handleEditOk = () => {
    setIsEditModalOpen(false);
  };
  const handleEditCancel = () => {
    setIsEditModalOpen(false);
  };

  const dispatch = useDispatch();

  const handlegetCostCenterNum = () => {
    // let payload =
    //   search !== '' ? { search: search } : { search: search, page: page };
    let payload = {
      search: search,
      page: page,
      user: 'admin' // Add the user property here
    };
    if (search === '') {
      delete payload.search; // Remove `search` if it's not needed
    }
    dispatch(getCostCenterNum(payload));
  };
  // handlegetIONum
  useEffect(() => {
    handlegetCostCenterNum();
  }, [search, page]);

  // const handleDelete = async (id) => {
  //   console.log('handleDelete', id);
  //   let payload = {
  //     id: id
  //   };
  //   dispatch(deleteCostCenter(payload));
  // };
  // useEffect(() => {
  //   handleGetPlants();
  // }, []);

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  useEffect(() => {
    console.log('search', search);
    const payload = { search: search };
    dispatch(getPlants(payload));
  }, [search]);

  useEffect(() => {
    console.log('search', departmentSearch);
    const payload = { search: departmentSearch };
    dispatch(getfunctions(payload));
  }, [departmentSearch]);

  const data = get_costcenterNums;
  const columns = [
    {
      // width: '60%',
      title: 'Plant',
      dataIndex: ['plant_master', 'name'],
      key: 'name',
      render: (text, record) => <>{record.plant_master?.name || '-'}</>
    },
    {
      // width: '60%',
      title: 'Department',
      dataIndex: ['department', 'function_name'],
      key: 'function_name',
      render: (text, record) => <>{record.department?.function_name || '-'}</>
    },
    {
      // width: '60%',
      title: 'Cost Center ',
      dataIndex: 'name',
      key: 'cost_center'
    },
    {
      width: '20%',
      title: 'Status',
      dataIndex: 'is_active',
      key: 'is_active',
      render: (status) => (
        <Tag color={status === true ? 'green' : 'red'}>
          {status === true ? 'Active' : 'Deactivated'}
        </Tag>
      )
    },
    {
      align: 'center',
      // width: '20%',
      title: 'Action',
      dataIndex: 'id',
      key: 'id',
      render: (id) => (
        <div style={{ display: 'flex', justifyContent: 'center', gap: 16 }}>
          <Tooltip title="Edit">
            <span
              className="cursor-pointer"
              onClick={() => {
                showEditModal(id);
              }}
            >
              {/* <Pencil /> */}
              <EditOutlined />
            </span>
          </Tooltip>
          {/* <Popconfirm
            title="Are you sure you want to delete this item?"
            onConfirm={() => handleDelete(id)}
            okText="Yes"
            cancelText="No"
          >
            <Tooltip title="Delete">
              <span className="cursor-pointer">
                <DeleteOutlined style={{ color: 'red' }} />
              </span>
            </Tooltip>
          </Popconfirm> */}
        </div>
      )
    }
  ];
  console.log('id', id);
  console.log('isEditModalOpen', isEditModalOpen);
  return (
    <CustomLayout sider={false}>
      {' '}
      <div className={`${styles.breadcrub_container}`}>
        {' '}
        <Row>
          <Col span={19}>
            <Breadcrumb separator={<RightOutlined />}>
              <Breadcrumb.Item href="/settings">Settings</Breadcrumb.Item>

              <Breadcrumb.Item
                className="sfprotext-medium font-14"
                href="/settings/costnumber"
              >
                Configure Cost Center
              </Breadcrumb.Item>
            </Breadcrumb>
          </Col>
          <Col className="text-right" span={4}>
            <Button
              onClick={showModal}
              className="font-14 sfprotext-bold "
              type="primary"
            >
              Add Cost Center
            </Button>
          </Col>
        </Row>
      </div>
      <Row>
        <Col span={18}>
          <div className="mt-3 font-16 sfprotext-bold">Cost Center</div>
        </Col>
        <Col span={6}>
          <SearchBar
            onChange={handleSearchChange}
            className={`mt-3 ${styles.createdSearch}`}
            inputProps={{
              placeholder: 'Search by cost center'
            }}
          />
        </Col>
      </Row>
      {data?.length === undefined ? (
        <>
          <div className="df-jc-ac mt-5">
            <img src={emptyState} />
          </div>
          <div className="df-jc-ac mt-3">
            <div className="sfprotext-regular font-14">
              You haven’t created any i/o no yet.
            </div>
          </div>
          <div className="df-jc-ac mt-3">
            <Button
              onClick={showModal}
              type="primary"
              className="sfprotext-bold font-14"
            >
              Add i/o no
            </Button>
          </div>
        </>
      ) : (
        <CustomTable
          //loading={tableLoading}
          rowKey={(id) => id.id}
          className={`mt-4 ${styles.custom_table}`}
          /*  rowSelection={true} */
          dataSource={data}
          columns={columns}
          pagination={{
            onChange: (page) => {
              setPage(page);
            },
            pageSize: 20,
            total: pagination?.total_records,
            showSizeChanger: false
          }}
        />
      )}
      {isModalOpen ? (
        <AddModal
          getCUSTNum_id={getCUSTNum_id}
          handlegetCostCenterNum={handlegetCostCenterNum}
          setIsModalOpen={setIsModalOpen}
          isModalVisible={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          setDepartmentSearch={setDepartmentSearch}
        />
      ) : null}
      {isEditModalOpen ? (
        <EditModal
          // byIdLoading={byIdLoading}
          handlegetCostCenterNum={handlegetCostCenterNum}
          id={id}
          setId={setId}
          getCUSTNum_id={getCUSTNum_id}
          setIsEditModalOpen={setIsEditModalOpen}
          isEditModalVisible={isEditModalOpen}
          onOk={handleEditOk}
          onCancel={handleEditCancel}
          setDepartmentSearch={setDepartmentSearch}
        />
      ) : null}
    </CustomLayout>
  );
};

export default Categories;
